import { DialogComponent } from '@theme/dialog';

/**
 * Account Navigation Drawer
 *
 * Extends DialogComponent to close the mobile header-drawer before opening,
 * preventing conflicting scroll-lock mechanisms between the details-based menu
 * and the dialog-based drawer.
 */
class AccountNavDrawerComponent extends DialogComponent {
  showDialog() {
    const headerDrawer = /** @type {{ isOpen: boolean, close: () => void, refs: { details: HTMLDetailsElement } } | null} */ (
      document.querySelector('header-drawer')
    );

    if (headerDrawer?.isOpen) {
      const details = headerDrawer.refs?.details;

      const openAfterClose = () => {
        requestAnimationFrame(() => super.showDialog());
      };

      if (details instanceof HTMLDetailsElement) {
        // Wait for the menu close animation to finish (reset() removes 'open',
        // firing the toggle event) before opening the account drawer.
        details.addEventListener('toggle', function handler() {
          if (!details.open) {
            details.removeEventListener('toggle', handler);
            openAfterClose();
          }
        });
      } else {
        // Fallback: approximate the menu close animation duration
        setTimeout(openAfterClose, 300);
      }

      headerDrawer.close();
    } else {
      super.showDialog();
    }
  }
}

if (!customElements.get('account-nav-drawer')) {
  customElements.define('account-nav-drawer', AccountNavDrawerComponent);
}
